import { render } from "./ScoreIcon.vue?vue&type=template&id=1c2616f7&ts=true"
import script from "./ScoreIcon.vue?vue&type=script&lang=ts"
export * from "./ScoreIcon.vue?vue&type=script&lang=ts"

import "./ScoreIcon.vue?vue&type=style&index=0&id=1c2616f7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__